import { CButton, CCard, CFormSelect } from '@coreui/react'
import useAxios from 'axios-hooks'
import React, { useContext, useEffect, useState } from 'react'
import { useParams, useLocation } from 'react-router-dom'
import { CustomDescriptionBox } from 'src/components'
import CustomMultiSelect from 'src/components/customMultiSelect/customMultiSelect'
import ToggleButtons from 'src/components/toggleButtons/toggleButtons'
import { AppContext } from 'src/views/context/app'
import { activeArray, raiseToast } from 'src/views/utils/helper'
import {
  AUDIENCE_API,
  USER_API,
  CUSTOM_FORM_API,
  AUDIENCE_CUSTOM_META_DATA_API,
  AUDIENCE_SOURCE_COUNT_API,
  SUBSCRIBER_USER_API,
} from 'src/views/utils/urls'
import CustomMetadata from 'src/components/CustomMetadata/CustomMetadata'
import { isEmpty } from 'lodash'
import { useHistory } from 'react-router-dom'

const CreateCampaignAudience = () => {
  const { audienceId } = useParams()
  const location = useLocation()
  const { setLoader } = useContext(AppContext)
  const isEdit = location.pathname.includes('/campaign/audience/edit/')
  const history = useHistory()

  const audienceTypeList = [
    {
      value: 'ALL',
      label: 'All',
    },
    {
      value: 'SUBSCRIBED',
      label: 'Subscribed',
    },
    {
      value: 'NOT_SUBSCRIBED',
      label: 'Not Subscribed',
    },
    {
      value: 'CUSTOM_FORM',
      label: 'Custom Form',
    },
  ]
  const [audienceCount, setAudienceCount] = useState(0)
  // const [audienceCountLoader, setAudienceCountLoader] = useState(false)
  const [audienceType, setAudienceType] = useState('')
  const [loadFiltering, setLoadFiltering] = useState(false)
  const [isStatic, setIsStatic] = useState(true)
  const [customForm, setCustomForm] = useState()
  const [audienceName, setAudienceName] = useState('')
  const [description, setDescription] = useState('')
  const [customMetadata, setCustomMetadata] = useState({})
  const [customFormMaster, setCustomFormMaster] = useState([])
  const [targetField, setTargetField] = useState('')
  const [targetList, setTargetList] = useState([])
  const [subscribedUsers, setSubscribedUsers] = useState([])
  const [subscribedUserMaster, setSubscribedUserMaster] = useState([])

  const [cmsUserMaster, setCmsUserMaster] = useState([])
  const [userGroupMaster, setUserGroupMaster] = useState([])
  const [cmsUser, setCmsUser] = useState([])
  const [userGroup, setUserGroup] = useState([])

  const [errorData, setErrorData] = useState({})

  const [{ data: audienceData, loading: audienceDataLoading }, audienceDataCall] = useAxios(
    {
      url: AUDIENCE_API,
      method: 'get',
    },
    { manual: true },
  )

  const [{ data: audienceCreate, loading: audienceCreateLoading }, audienceCreateCall] = useAxios(
    {
      url: AUDIENCE_API,
      method: 'post',
    },
    { manual: true },
  )

  const [{ data: audienceUpdate, loading: audienceUpdateLoading }, audienceUpdateCall] = useAxios(
    {
      url: AUDIENCE_API,
      method: 'put',
    },
    { manual: true },
  )

  const [{ data: cmsUserList, loading: cmsUserListLoading }, cmsUserListCall] = useAxios(
    {
      url: `${USER_API}/cms-user`,
      method: 'get',
    },
    { manual: true },
  )

  const [{ data: userGroupList, loading: userGroupListLoading }, userGroupListCall] = useAxios(
    {
      url: `${USER_API}/user-group`,
      method: 'get',
    },
    { manual: true },
  )

  const [{ data: formList, loading: formListLoading }, formListCall] = useAxios(
    {
      url: CUSTOM_FORM_API,
      method: 'get',
    },
    { manual: true },
  )

  const [{ data: customMetadataList, loading: customMetadataLoading }, customMetadataCall] =
    useAxios(
      {
        url: AUDIENCE_CUSTOM_META_DATA_API,
        method: 'get',
      },
      { manual: true },
    )

  const [{ data: audienceCountData, loading: audienceCountDataLoading }, audienceCountDataCall] =
    useAxios(
      {
        url: AUDIENCE_SOURCE_COUNT_API,
        method: 'post',
      },
      { manual: true },
    )

  const [{ data: subscribedUserList, loading: subscribedUserListLoading }, subscribedUserListCall] =
    useAxios(
      {
        url: SUBSCRIBER_USER_API,
        method: 'get',
      },
      { manual: true },
    )

  useEffect(() => {
    if (!isStatic) {
      if (audienceType === 'CUSTOM_FORM') {
        if (targetField !== '' && customForm !== '') {
          audienceCountDataCall({
            data: {
              audience_type: audienceType,
              audience_entities: {
                form_id: customForm,
                field_name: targetField,
              },
            },
          })
        }
      } else {
        audienceCountDataCall({
          data: {
            audience_type: audienceType,
            audience_entities: {},
          },
        })
      }
    } else {
      setAudienceCount(subscribedUsers?.length)
    }
  }, [audienceType, targetField, subscribedUsers])

  useEffect(() => {
    if (audienceCountData && audienceCountData.success) {
      setAudienceCount(audienceCountData.data?.audience_count)
    }
  }, [audienceCountData])

  useEffect(() => {
    if (isEdit && audienceId) {
      audienceDataCall({
        params: {
          audience_id: audienceId,
        },
      })
    }
    if (!isEdit) {
      setAudienceName(location?.state?.name ? location.state.name : '')
    }
  }, [location])

  useEffect(async () => {
    customMetadataCall()
    userGroupListCall()
    cmsUserListCall()
    formListCall()
    subscribedUserListCall({
      params: {
        page: 1,
        page_size: 100,
      },
    })
  }, [])

  useEffect(() => {
    if (customFormMaster.length > 0) {
      let arrayResponse = customFormMaster.filter((info) => info._id === customForm)
      setTargetList(arrayResponse[0]?.fields?.data.filter((f) => f.type === 'EMAIL'))
      setTargetField('')
    }
  }, [customForm, customFormMaster])

  useEffect(() => {
    setLoader(
      audienceDataLoading ||
        cmsUserListLoading ||
        userGroupListLoading ||
        customMetadataLoading ||
        audienceCreateLoading ||
        audienceUpdateLoading ||
        formListLoading ||
        audienceCountDataLoading ||
        subscribedUserListLoading,
    )
  }, [
    audienceDataLoading,
    cmsUserListLoading,
    userGroupListLoading,
    customMetadataLoading,
    audienceCreateLoading,
    audienceUpdateLoading,
    formListLoading,
    audienceCountDataLoading,
    subscribedUserListLoading,
  ])

  useEffect(() => {
    if (
      audienceData &&
      audienceData.success &&
      !isEmpty(cmsUserMaster) &&
      !isEmpty(userGroupMaster) &&
      !isEmpty(subscribedUserMaster)
    ) {
      setAudienceName(audienceData?.data?.name)
      setDescription(audienceData?.data?.description)
      setIsStatic(audienceData?.data?.is_static === true)
      setAudienceType(audienceData?.data?.audience_type)
      setCustomForm(audienceData?.data?.audience_entities?.form_id)
      setTargetField(audienceData?.data?.audience_entities?.field_name)
      setCustomMetadata(audienceData?.data?.custom_metadata)

      if (!isEmpty(audienceData?.data?.cms_users)) {
        let data = audienceData?.data?.cms_users
        let tempArr = []
        for (let i = 0; i < data.length; i++) {
          const id = data[i]

          let obj = cmsUserMaster.find((info) => info._id === id)
          if (obj) {
            tempArr.push(obj)
          }
        }

        setCmsUser([...tempArr])
      }
      if (!isEmpty(audienceData?.data?.user_groups)) {
        let data = audienceData?.data?.user_groups
        let tempArr = []
        for (let i = 0; i < data.length; i++) {
          const id = data[i]
          let obj = userGroupMaster.find((info) => info._id === id)
          if (obj) {
            tempArr.push(obj)
          }
        }

        setUserGroup([...tempArr])
      }
      if (!isEmpty(audienceData?.data?.audience_entities?.users)) {
        let data = audienceData?.data?.audience_entities?.users
        let tempArr = []
        for (let i = 0; i < data.length; i++) {
          const id = data[i]

          let obj = subscribedUserMaster.find((info) => info._id === id)
          if (obj) {
            tempArr.push(obj)
          }
        }

        setSubscribedUsers([...tempArr])
      }
    }
  }, [audienceData, cmsUserMaster, userGroupMaster, subscribedUserMaster])

  useEffect(() => {
    if (audienceCreate && audienceCreate.success) {
      raiseToast('success', 'Campaign Audience Created Successfully')
      history.push(`/campaign/audience/list`)
    }
  }, [audienceCreate])

  useEffect(async () => {
    if (audienceUpdate && audienceUpdate.success) {
      raiseToast('success', 'Campaign Audience Updated Successfully!')
      history.push(`/campaign/audience/list`)
    }
  }, [audienceUpdate])

  useEffect(() => {
    if (userGroupList && userGroupList.success) {
      setUserGroupMaster(userGroupList.data)
    }
  }, [userGroupList])

  useEffect(() => {
    if (subscribedUserList && subscribedUserList.success) {
      setSubscribedUserMaster(subscribedUserList.data)
    }
  }, [subscribedUserList])

  useEffect(() => {
    if (cmsUserList && cmsUserList.success) {
      setCmsUserMaster(cmsUserList.data)
    }
  }, [cmsUserList])

  useEffect(() => {
    if (formList && formList.success) {
      setCustomFormMaster(formList.data)
    }
  }, [formList])

  const validateInfo = () => {
    let isFormValid = true
    let temp = {}

    if (audienceName.trim().length === 0) {
      isFormValid = false
      temp.audienceName = 'CampaignAudience name cannot be empty!'
    }
    if (isStatic) {
      if (subscribedUsers.length === 0) {
        isFormValid = false
        raiseToast('error', 'Please select users')
      }
    } else {
      if (isEmpty(audienceType)) {
        isFormValid = false
        raiseToast('error', 'Please select audience type')
      } else {
        if (audienceType === 'CUSTOM_FORM' && isEmpty(targetField)) {
          raiseToast('error', 'Please select proper form criteria to create audience')
        }
      }
    }

    setErrorData({ ...temp })
    return isFormValid
  }

  const handleCreate = () => {
    if (!validateInfo()) {
      return
    }

    audienceCreateCall({
      data: {
        name: audienceName,
        audience_type: isStatic ? 'STATIC' : audienceType,
        description: description,
        cms_users: cmsUser.map((info) => info._id),
        user_groups: userGroup.map((info) => info._id),
        custom_metadata: customMetadata,
        is_static: isStatic,
        audience_entities: isStatic
          ? { users: subscribedUsers.map((info) => info._id) }
          : {
              form_id: customForm,
              field_name: targetField,
            },
      },
    })
  }

  const handleUpdate = () => {
    audienceUpdateCall({
      params: {
        audience_id: audienceId,
      },
      data: {
        name: audienceName,
        audience_type: isStatic ? 'STATIC' : audienceType,
        description: description,
        cms_users: cmsUser.map((info) => info._id),
        user_groups: userGroup.map((info) => info._id),
        custom_metadata: customMetadata,
        is_static: isStatic,
        audience_entities: isStatic
          ? { users: subscribedUsers.map((info) => info._id) }
          : {
              form_id: customForm,
              field_name: targetField,
            },
      },
    })
  }

  const selectCustomForm = (e) => {
    setCustomForm(e.target.value)
  }

  const selectAudienceType = (e) => {
    setAudienceType(e.target.value)
  }

  useEffect(() => {
    if (audienceType === 'CUSTOM_FORM') {
      setLoadFiltering(true)
    } else {
      setLoadFiltering(false)
      setCustomForm('')
      setTargetField('')
    }
  }, [audienceType])

  return (
    <div>
      <div className="d-flex justify-content-between align-items-center mt-4">
        <div>
          <h4>Audience</h4>
          <p>Following are the Audience which are already in your store.</p>
        </div>
      </div>
      <CCard
        style={{
          height: '68vh',
          overflowX: 'hidden',
          paddingLeft: '2.135vw',
          paddingRight: '2.135vw',
          paddingTop: '2.5vw',
          paddingBottom: '2.5vw',
        }}
        className="custom-scrollbar-vertical "
      >
        <div className="w-100">
          <div
            style={{ background: '#e2e2e2', fontWeight: '550', fontSize: '0.8333vw' }}
            className="w-100 rounded pl-4"
          >
            Basic Properties
          </div>
          <div className="w-100 pl-4 pr-1 d-flex justify-content " style={{ marginTop: '1.355vw' }}>
            <div style={{ width: '35%' }}>
              <div className="mb-0">
                <h6 style={{ fontSize: '.8333vw' }}>Select Audience Type</h6>
                <ToggleButtons
                  toggle={isStatic}
                  setToggle={setIsStatic}
                  trueOption={'Static'}
                  falseOption={'Dynamic'}
                  toggleWidth="33%"
                />
              </div>
              <div style={{ width: '83%', margin: '29px 0px 0px 0px' }} className="">
                <h6 style={{ fontSize: '.8333vw' }}>{isStatic ? 'Users' : 'Source Type'}</h6>
                {isStatic ? (
                  <div style={{ width: '90%' }} className="">
                    <CustomMultiSelect
                      selectedValue={subscribedUsers}
                      optionsData={subscribedUserMaster}
                      onChange={setSubscribedUsers}
                      labelKey="name"
                    />
                  </div>
                ) : (
                  <CFormSelect value={audienceType} onChange={selectAudienceType} size="sm">
                    <option value="" selected disabled>
                      Select Source Type
                    </option>
                    {audienceTypeList.map((info, idx) => (
                      <option key={idx} value={info.value}>
                        {info?.label}
                      </option>
                    ))}
                  </CFormSelect>
                )}
                {audienceType !== 'CUSTOM_FORM' && audienceType !== '' && (
                  <h6 style={{ fontSize: '14px', margin: '10px 0px 0px 0px' }}>
                    * Approx. audience count: {audienceCount}
                  </h6>
                )}
              </div>
            </div>
            <div style={{ width: '53%' }} className="">
              <div>
                <h6 style={{ fontSize: '.8333vw' }}>
                  Audience Name <span style={{ color: 'red' }}>*</span>
                </h6>
                <CustomDescriptionBox
                  limit={50}
                  rows={1}
                  value={audienceName}
                  onChange={(value) => {
                    setAudienceName(value)
                  }}
                  isMandatory={true}
                  errorText={errorData[`audienceName`]}
                  style={{ fontSize: '13px' }}
                  useFormInput={true}
                />
              </div>
              <div>
                <h6 style={{ fontSize: '.8333vw' }}>Description</h6>
                <CustomDescriptionBox
                  limit={150}
                  rows={2}
                  value={description}
                  onChange={(value) => {
                    setDescription(value)
                  }}
                  errorText={errorData[`description`]}
                  style={{ fontSize: '13px' }}
                />
              </div>
            </div>
          </div>
        </div>
        {loadFiltering && (
          <div className="w-100 mt-4">
            <div
              style={{ background: '#e2e2e2', fontWeight: '550', fontSize: '0.8333vw' }}
              className="w-100 rounded pl-4"
            >
              Filtering Criteria
            </div>
            <div
              className=" pl-4 pr-1 d-flex justify-content-between "
              style={{ marginTop: '1.355vw', width: '100%' }}
            >
              <div style={{ width: '29%' }} className="">
                <h6 style={{ fontSize: '.8333vw' }}>Custom Form</h6>
                <CFormSelect value={customForm} onChange={selectCustomForm} size="sm">
                  <option value="" selected disabled>
                    Select Custom Form
                  </option>
                  {customFormMaster.map((info, idx) => (
                    <option key={idx} value={info._id}>
                      {info?.name}
                    </option>
                  ))}
                </CFormSelect>
              </div>
              <div style={{ width: '29%' }} className="">
                <h6 style={{ fontSize: '.8333vw' }}>Target Field</h6>
                <CFormSelect
                  value={targetField}
                  onChange={(e) => {
                    setTargetField(e.target.value)
                  }}
                  size="sm"
                >
                  <option value="" selected disabled>
                    Select Target Field
                  </option>
                  {targetList?.map((info, idx) => (
                    <option key={idx} value={info.name}>
                      {info?.name}
                    </option>
                  ))}
                </CFormSelect>
              </div>
              <h6 style={{ fontSize: '10px', width: '29%', margin: '30px 0px 0px 0px' }}>
                * Approx. audience count: {audienceCount}
              </h6>
            </div>
          </div>
        )}
        <div className="w-100 mt-4">
          <div
            style={{ background: '#e2e2e2', fontWeight: '550', fontSize: '0.8333vw' }}
            className="w-100 rounded pl-4"
          >
            Visibility and Permissions
          </div>
          <div
            className=" pl-4 pr-1 d-flex justify-content-between "
            style={{ marginTop: '1.355vw', width: '65%' }}
          >
            <div style={{ width: '45%' }} className="">
              <h6 style={{ fontSize: '.8333vw' }}>CMS Users</h6>
              <CustomMultiSelect
                selectedValue={cmsUser}
                optionsData={cmsUserMaster}
                onChange={setCmsUser}
                labelKey="name"
              />
            </div>
            <div style={{ width: '45%' }} className="">
              <h6 style={{ fontSize: '.8333vw' }}>CMS User Groups</h6>
              <CustomMultiSelect
                selectedValue={userGroup}
                optionsData={userGroupMaster}
                onChange={setUserGroup}
                labelKey="name"
              />
            </div>
          </div>
        </div>
        <div className="w-100 mt-4">
          <div
            style={{ background: '#e2e2e2', fontWeight: '550', fontSize: '0.8333vw' }}
            className="w-100 rounded pl-4"
          >
            Custom Properties
          </div>
          <div
            className="w-100 pl-4 pr-1 d-flex justify-content-between "
            style={{ marginTop: '0.3vw' }}
          >
            {customMetadataList && !isEmpty(customMetadataList?.data) && (
              <CustomMetadata
                isEdit={isEdit}
                editData={isEdit ? { custom_metadata: customMetadata } : {}}
                customMetadataMaster={activeArray(customMetadataList.data)}
                customPayload={customMetadata}
                setCustomPayload={setCustomMetadata}
                column={3}
              />
            )}
          </div>
        </div>
      </CCard>
      <div className="w-100 d-flex justify-content-end mt-2">
        <CButton
          className="px-3 mx-4 text-black border"
          onClick={() => {
            history.push(`/campaign/audience/list`)
          }}
          style={{
            pointerEvents: 'auto',
            fontSize: '18px',
            background: 'inherit',
            border: 'solid 1.5px #bdbdbd',
          }}
        >
          Cancel
        </CButton>
        <CButton
          className="text-white px-3"
          onClick={isEdit ? handleUpdate : handleCreate}
          style={{ pointerEvents: 'auto', fontSize: '18px', background: '#20211c' }}
        >
          Save
        </CButton>
      </div>
    </div>
  )
}

export default CreateCampaignAudience
